


























import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { InsertCity, UpdateCity } from "@/api/pdTeam";
@Component
export default class PdCityDetail extends AbpBase {
    @Prop() data: any;
    model: any = {};
    communityList: any = [];
    rules = {
        code: [
            {
                required: true,
                message: "小区编码不能为空",
                trigger: "blur",
            },
        ],
        name: [
            {
                required: true,
                message: "小区名称不能为空",
                trigger: "blur",
            },
        ],
    };

    @Watch("data", { immediate: true, deep: true })
    onDataChanged() {
        if (this.data) {
            this.model = Object.assign({}, this.data);
        }
    }

    async submit() {
        let validResult = false;
        this.$refs["form"].validate((valid) => {
            if (valid) {
                validResult = true;
            }
        });
        if (validResult) {
            if (this.model.id == 0) {
                await InsertCity(this.model);
            } else {
                await UpdateCity(this.model);
            }
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/city/detail.vue